module.exports = {"type":"Development Tracking","dat":[{"name":"Dev App Toronto","layer":"dev app toronto","toggle":false,"names":["Dev App Toronto"]}]}


//////////////////
// WEBPACK FOOTER
// ./public/data/devapp_sidebar.json
// module id = PxFf
// module chunks = 1